(function(){
  const STORAGE_KEY = "upcartTimerEnd";
  const DURATION_MINUTES = 10;

  function startTimer() {
    const timerEl = document.getElementById("timer");
    const container = document.getElementById("cart-timer");
    if(!timerEl || !container) return; // drawer not open yet

    let endTime = localStorage.getItem(STORAGE_KEY);
    if(!endTime){
      endTime = Date.now() + DURATION_MINUTES * 60 * 1000;
      localStorage.setItem(STORAGE_KEY, endTime);
    } else {
      endTime = parseInt(endTime,10);
    }

    function pad(n){return String(n).padStart(2,"0");}

    function update(){
      const now = Date.now();
      const secs = Math.max(0, Math.floor((endTime - now)/1000));
      const m = Math.floor(secs/60);
      const s = secs % 60;
      timerEl.textContent = pad(m)+":"+pad(s);

      if(secs<=0){
        clearInterval(intv);
        container.innerHTML = "⏰ Deine Reservierung ist abgelaufen!";
        localStorage.removeItem(STORAGE_KEY);
      }
    }

    const intv = setInterval(update,1000);
    update();
  }

  // Run once drawer is opened / element exists
  document.addEventListener("DOMContentLoaded", startTimer);
  document.addEventListener("click", () => setTimeout(startTimer, 500)); 
})();
